import React from 'react'
import './BookingMetrics.css'
import { DataGridComponent, PaginationComponent } from "../../Components/PaginationComponent";
import { useSelector } from 'react-redux';
import { BookingMetricsData } from '../../StaticData';


const BookingMetrics = () => {
    const bookingDataMetrics = useSelector((state) => state.bookingMetricsData)
    const columns = [
        {
            field: "EventID",
            headerName: "Event ID",
            width: 150,
            headerClassName: "custom-header",
            renderCell: (params) => <span style={{ color: '#0B63F8' }}>{params.value}</span>
        },
        {
            field: "Start_location",
            headerName: "Start location",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
            renderCell: (params) => <span style={{ color: '#0B63F8' }}>{params.value}</span>
        },
        {
            field: "Full_Name",
            headerName: "Organiser",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Tripsattended",
            headerName: "Trips attended",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Total_Revenue",
            headerName: "Total Revenue",
            width: 200,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Total_cashback",
            headerName: "Total cashback",
            width: 200,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Event_Date",
            headerName: "Event Date",
            width: 200,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "Organiser_profit",
            headerName: "Organiser profit",
            width: 200,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
    ];

    const rows = BookingMetricsData?.map((item) => ({
        id: item.EventID,
        _id: item?._id,
        EventID: item.EventID,
        Start_location: item.Start_location,
        Full_Name: item.Full_Name,
        Tripsattended: item.my_events,
        Total_Revenue: item.Total_Revenue,
        Total_cashback: item.Total_cashback,
        Event_Date: item.Event_Date,
        Organiser_profit: item.Organiser_profit,
        event_object_id: item?._id,
    }));

    return (
        <div>
            <div className="event-info-container">
                <div className="All-details-container">
                    <div className="organiser-details">
                        <h5 className="info-side-heading">Total Revenue</h5>
                        <p className="info-content">{bookingDataMetrics?.totalRevenue} </p>
                    </div>
                    <div className="organiser-details">
                        <h5 className="info-side-heading">Total users booked paid events </h5>
                        <p className="info-content">{bookingDataMetrics?.totalUsersBookedPaid}</p>
                    </div>
                    <div className="organiser-details">
                        <h5 className="info-side-heading">Total users booked free events </h5>
                        <p className="info-content">{bookingDataMetrics?.totalUsersBookedFree}</p>
                    </div>
                    <div className="organiser-details">
                        <h5 className="info-side-heading">Total free cancellations</h5>
                        <p className="info-content">{bookingDataMetrics?.totalCancellationsFree}</p>
                    </div>
                    <div className="organiser-details">
                        <h5 className="info-side-heading">Total paid cancellations </h5>
                        <p className="info-content"> {bookingDataMetrics?.totalCancellationsPaid} </p>
                    </div>
                </div>
            </div>
            <br></br>
            <div className="event-information-container-2">
                <div class="section">
                    <div className='headings'>
                        <div className='list-users-container'>
                            <p className='list-users'>Total Revenue by country / Month</p>
                        </div>
                    </div>
                    <div className="All-details-container">
                        <div className="organiser-details">
                            <h5 className="info-side-no">1</h5>
                            <h5 className="middle-heading">Germany</h5>
                            <p className="info-content1">10</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">2</h5>
                            <h5 className="middle-heading">India</h5>
                            <p className="info-content1">8</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">3</h5>
                            <h5 className="middle-heading">Spain</h5>
                            <p className="info-content1">8</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">4</h5>
                            <h5 className="middle-heading">Afganisthan</h5>
                            <p className="info-content1">8</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">5</h5>
                            <h5 className="middle-heading">Andora</h5>
                            <p className="info-content1">8</p>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <div className='headings'>
                        <div className='list-users-container'>
                            <p className='list-users'>Total Revenue generated from an  Organiser</p>
                        </div>
                    </div>
                    <div className="All-details-container">
                        <div className="organiser-details">
                            <h5 className="info-side-no">1</h5>
                            <h5 className="middle-heading">Praveen Killi</h5>
                            <p className="info-content1">10</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">2</h5>
                            <h5 className="middle-heading">Lavanya</h5>
                            <p className="info-content1">8</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">3</h5>
                            <h5 className="middle-heading">sneha</h5>
                            <p className="info-content1">8</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">4</h5>
                            <h5 className="middle-heading">sony</h5>
                            <p className="info-content1">8</p>
                        </div>
                        <div className="organiser-details">
                            <h5 className="info-side-no">5</h5>
                            <h5 className="middle-heading">Gopal</h5>
                            <p className="info-content1">8</p>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ marginTop: '50px' }}>
                <DataGridComponent columns={columns} rows={rows} rowCount={rows.length} />
            </div>
            <br></br>
            <div className='Total-count'>
                <p className='Amount'>Total Amount </p>
                <p className='Total-Rup'>150</p>
            </div>
        </div>
    )

}

export default BookingMetrics